function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { useField } from 'formik';

// Local Definitions

import "./styles.scss";
import { FormLabel, FormDescription } from "../../common";
const baseClassName = styleNames.base;
const componentClassName = 'text-area-input';

/**
 * This is the component description.
 */
const TextareaInput = ({
  id,
  className: userClassName,
  style,
  name,
  label,
  validate,
  color,
  rows,
  optional,
  labelColor,
  description,
  disabled,
  placeholder,
  autoComplete,
  resize
  // ...otherProps
}) => {
  const [field] = useField({
    name,
    validate
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, `y-${color}`].filter(e => e).join(' '),
    style: style
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    name: name,
    color: labelColor,
    optional: optional
  }, label), /*#__PURE__*/React.createElement("textarea", _extends({
    id: name,
    className: "textarea"
  }, field, {
    style: {
      resize
    },
    placeholder: placeholder,
    rows: rows,
    disabled: disabled,
    autoComplete: autoComplete
  })), /*#__PURE__*/React.createElement(FormDescription, {
    className: "s-1",
    description: description,
    name: name
  }));
};
TextareaInput.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The input name (html - and Formik state)
   */
  name: PropTypes.string.isRequired,
  /**
   * The input label
   */
  label: PropTypes.string.isRequired,
  /**
   * The input value validator function
   */
  validate: PropTypes.func,
  /**
   * If the text area depends on it's label's text as the default description
   */
  labelAsDescription: PropTypes.bool,
  /**
   * The textarea id
  */
  textAreaId: PropTypes.string,
  /**
   * The number of rows int the text area
   */
  rows: PropTypes.number,
  /**
   * Color of the text
   */
  color: PropTypes.string,
  /**
   * Label base color
   */
  labelColor: PropTypes.string,
  /**
   * Text area description
   */
  description: PropTypes.string,
  /**
   * Whether the text area should be disabled
   */
  disabled: PropTypes.bool,
  /**
   * The textarea placeholder text
   */
  placeholder: PropTypes.string,
  /**
   * The autoComplete value that the browser should watch for the input
   */
  autoComplete: PropTypes.string,
  /**
   * Whether to disable or allow only a certain method of resizing the area
   * Textarea docs - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
   */
  resize: PropTypes.string,
  /**
  * Whether the input is optional or not
  */
  optional: PropTypes.bool
};
TextareaInput.defaultProps = {
  rows: 10,
  disabled: false,
  resize: 'vertical',
  color: 'paragraph'
};
export default /*#__PURE__*/memo(TextareaInput);